import "./map.css";

export const Map = () => (
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2562.167424951017!2d18.43358607634371!3d50.0456948715177!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47114550c7780f5d%3A0xca2184920b1311ef!2zR8WCb8W8ecWEc2thIDIwMEUsIDQ0LTMxMCBSYWRsaW4!5e0!3m2!1sen!2spl!4v1685131663365!5m2!1sen!2spl"
    title="map"
    allowFullScreen
  />
);
